module.exports = __webpack_public_path__ + "static/media/gu.8e7dc4dc.svg";